import CSS from './page-header.module.css'

export function PageHeader({ children, theme }) {
    
    return (
        <section className={`${CSS.container} bg-default`} >

            <div className={CSS.heroGraphic} style={{ textAlign: `right`}}>
                <video
                    src="/assets/theme/2027/2027-theme-animation.mp4"
                    height={`90%`}
                    muted
                    autoPlay
                    loop
                    playsInline
                    style={{
                        marginTop: `0`
                    }}
                />
            </div>

            <section className={`${CSS.content} block bg-default`}>
                {children}
            </section>
         
        </section>
    )

}

